import { render, staticRenderFns } from "./dingzhi.vue?vue&type=template&id=3c12bab8&scoped=true&"
import script from "./dingzhi.vue?vue&type=script&lang=js&"
export * from "./dingzhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12bab8",
  null
  
)

export default component.exports